export default __webpack_public_path__ + "static/DASTA-472f74a4ea12e5d15be7e8782e828496.png";